export default {
  searching: 'Recherche en cours',
}
